<template>
  <AppModal :id="id" :size="size">
    <template v-slot:title>
      <h3 class="text-center mb-5">{{ $t($getConst.pages.connectivity_test.payload_details) }} : {{job.id}} </h3>
    </template>
    <template v-slot:content>
      <pre>{{ JSON.stringify(job.payload, null, 2) }}</pre>
    </template>
    <template v-slot:button>
      <AppConfirmButtons :firstButton="false"
        @onCancel="close"
      />
    </template>
  </AppModal>
</template>

<script>
  import AppModal from "../../../../components/common/modals/AppModal";
  import AppConfirmButtons from "../../../../components/common/utils/AppConfirmButtons";

  export default {
    name: "ShowPayloadDetailsModal",
    components: {AppConfirmButtons, AppModal},
    props: {
      id: String,
      job: null,
      size: String
    },
    methods: {
      close() {
        this.$bvModal.hide(this.id);
        this.$emit('onCancel');
      },
    }
  }
</script>

<style scoped>

</style>
